import React from 'react';
import styled from '@emotion/styled';
import Layout from './Layout';
import StaticHeaderCover from '../StaticHeaderCover';
import { Text } from '../styles';

const Container = styled.div({
  maxWidth: '54rem',
  margin: '0 auto',
  position: 'relative',
  zIndex: 2,
});

const Title = styled(Text)(({ theme }) => ({
  bottom: theme.spacing(8),
  position: 'absolute',
  width: '100%',
  zIndex: 3,
  [theme.breakpoints.down('md')]: {
    bottom: theme.spacing(5),
  },
}));

type LayoutProps = {
  children?: React.ReactNode,
  cover: string,
  title?: string,
  containCover?: boolean,
} & React.ComponentPropsWithoutRef<typeof Container>;

export default function StaticLayout({ cover, title, containCover, children, ...rest }: LayoutProps) {
  return (
    <>
      <StaticHeaderCover image={cover} containCover={containCover}>
        {title && <Title variant="h1" align="center">{title}</Title>}
      </StaticHeaderCover>
      <Layout disableTopGutter>
        <Container {...rest}>
          {children}
        </Container>
      </Layout>
    </>
  );
}
